import { MENU_OPTIONS } from '../constants';

export const sanitizeImageUrl = (url = '') => url.replace(/<SIZE>/g, '400');

export const getDefaultMenu = (menuName) => {
  if (!menuName) {
    return null;
  }

  const isValidMenu = Object.values(MENU_OPTIONS).includes(menuName);
  return isValidMenu ? menuName : null;
};
